import React from 'react';
import '../styles/Footer.css';

import { FaFacebookF, FaTwitter, FaLinkedinIn, FaYoutube, FaInstagram } from 'react-icons/fa';

const Footer = () => (
  <footer className="footer">
    <p>&copy; {new Date().getFullYear()} CVEY Solutions. All rights reserved.</p>
    <div className="social-icons">
      <a href="#"><FaFacebookF /></a>
      <a href="#"><FaTwitter /></a>
      <a href="#"><FaLinkedinIn /></a>
      <a href="#" aria-label="YouTube"><FaYoutube /></a>
      <a href="#" aria-label="Instagram"><FaInstagram /></a>
    </div>
    <p>
      8B, Gopal Nagar Society,
      Vishwambhar Enclave, Hafeezpet,
      Hyderabad, Telangana– 500085
      Mobile: +91 8985756339<br />
      <a href="mailto:kvrsnsg@cveysolutions.in" style={{ color: '#fff', textDecoration: 'underline' }}>
        support@cveysolutions.in
      </a>
    </p>

  </footer>
);

export default Footer;
